import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { useLocation, useNavigate } from "react-router-dom";
import "leaflet/dist/leaflet.css";
import customMarkerIcon from "../utils/leafletIcon";
import UXHint from "../components/UXHint";

const ClientMap = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const scans = location.state?.scans || [];

  // 🧭 Coordonnées par défaut (Cayenne)
  const defaultPosition = [4.933, -52.33];

  // 🗺️ Construction de la liste des positions des produits scannés
  const positions = scans
    .map((scan) => {
      // 👉 Cherche la position du produit
      const lat = scan.product?.location?.lat || scan.location?.lat || null;
      const lng = scan.product?.location?.lng || scan.location?.lng || null;

      // Ignore si pas de coordonnées valides
      if (lat === null || lng === null) return null;

      return {
        ...scan,
        position: [lat, lng],
      };
    })
    .filter(Boolean); // enlève les null

  if (!positions.length) {
    return (
      <div className="p-6 text-center">
        <p className="text-lg text-gray-700">
          Aucun produit géolocalisé à afficher pour le moment.
        </p>
        <button
          onClick={() => navigate("/client")}
          className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
        >
          ⬅️ Retour à l’historique
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-gray-800">
          🗺️ Vos produits scannés sur la carte
        </h2>
        <button
          onClick={() => navigate("/client")}
          className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
        >
          ⬅️ Retour à l’historique
        </button>
      </div>

      {/* C — Aide carte */}
      <UXHint
        id="client_map"
        text="Cette carte affiche les produits que vous avez scannés autour de vous. Seuls les scans avec géolocalisation activée apparaissent ici."
        style={{ marginBottom: "16px" }}
      />

      <div className="rounded-xl overflow-hidden shadow-lg border border-gray-300">
        <MapContainer
          center={positions[0]?.position || defaultPosition}
          zoom={6}
          style={{ height: "80vh", width: "100%" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="© OpenStreetMap"
          />
          {positions.map((scan, index) => (
            <Marker key={index} position={scan.position} icon={customMarkerIcon}>
              <Popup>
                <strong>{scan.articleName || "Article inconnu"}</strong>
                <br />
                {scan.product?.city && <span>📍 {scan.product.city}</span>}
                <br />
                {new Date(scan.date).toLocaleString()}
                <br />
                <span>
                  👤 Vendu par :{" "}
                  <strong>{scan.ownerName || scan.product?.ownerName || "Inconnu"}</strong>
                </span>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
    </div>
  );
};

export default ClientMap;
